<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      kgoBodyHeight: document.body.clientHeight - 98 - 32,
      isRouterAlive: true
    }
  },
  mounted() {
    // var pagename_one = window.location.host
    // if (pagename_one.indexOf("aiosign.com") >= 0) {
    //   this.new_url = 'https://' + pagename_one
    // } else {
    //   this.new_url = 'https://test.aiosign.com:2800'
    // }
    // if(window.screen.width>750){
    //   window.location.href= this.new_url+'/web/index.html#/'
    // }else if(window.screen.width<750) {
    //   window.location.href= this.new_url+'/h5/index.html#/'
    // }

    var bo = document.body
    var ht = document.documentElement
    var w = window.screen.width
    if (w > 750) {
      ht.style.minWidth = '1240px'
      bo.style.minWidth = '1240px'
    } else {
      ht.style.minWidth = '240px'
      bo.style.minWidth = '240px'
    }
    window.onresize = function () {
      var h = document.body.clientHeight
      var bo = document.body
      var ht = document.documentElement
      ht.style.height = h + 'px'
      bo.style.height = h + 'px'
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  created() {
    var pageViewHeigh = document.body.clientHeight - 85 - 15
    this.$store.commit('SET_PAGE_VIEW_HEIGH', { height: pageViewHeigh })
  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  font-family: SourceHanSansCN-Light, SourceHanSansCN;
}
body,
html {
  height: 100%;
  border: none;
  padding: 0;
  margin: 0;
  background-color: $bg-color;
  /*min-width: 1240px;*/
}
a {
  text-decoration: none;
}
#app {
  height: 100%;
}
#sign-content {
  background-color: $theme-color;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #0fc87d;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #cdcdcd;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #0099dd;
  /*滚动条阴影*/
  scrollbar-shadow-color: #cdcdcd;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #fff;
  /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
  scrollbar-3dlight-color: #0099dd;
  /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
  scrollbar-darkshadow-color: #0099dd;
  /*滚动条基准颜色*/
  scrollbar-base-color: #0099dd;
}
body .el-table th.gutter {
  display: table-cell !important;
}
#app::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}

#app::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

#app::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.sign-page-content {
  width: 1180px;
  margin: 0 auto;
  margin-top: 8px;
  position: relative;
}
#app .el-dialog__header {
  padding: 0;
  background-color: #31ca84;
  line-height: 35px;
}
#app .el-dialog__title {
  line-height: 35px;
  color: #ffffff;
  font-size: 16px;
}
#app .el-dialog {
  border-radius: 4px;
  overflow: hidden;
  width: 617px;
}
#app .el-dialog__headerbtn {
  font-size: 19px;
  top: 0px;
  right: 13px;
  height: 37px;
}
#app .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
#app .dialog-footer .el-button {
  padding: 0 10px;
  line-height: 33px;
  height: 33px;
  min-width: 117px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  margin: 0 13px;
}
#app .dialog-footer .el-button--default {
  border-color: #19bc73;
  color: #19bc73;
  font-weight: normal;
}
.el-pagination {
  margin: 9px auto;
  text-align: center;
}
</style>
<style type="text/css">
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>